import React from 'react';

export interface FooterLink {
    order: number;
    label: string;
    url: string;
}

interface IProps {
    footerLink: FooterLink;
    deleteFooterLink: () => void;
}

export const WebsiteFooterLinkView = (props: IProps) => {
    return (
        <>
            <div className='flex p-bottom-15px center presenters-list'>
                <label className='oe-form-field__title m-right-11px w-100'>
                    Footer Link URL
                    <input
                        type='text'
                        className='oe-form-field__control'
                        placeholder='URL'
                        value={ props.footerLink?.url || '' }
                        readOnly={true}
                    />
                </label>
                <label className='oe-form-field__title w-100'>
                    Footer Link Label
                    <input
                        type='text'
                        className='oe-form-field__control'
                        placeholder='Label'
                        value={ props.footerLink?.label || '' }
                        readOnly={true}
                    />
                </label>
                <span className='material-icons text-blue p-top-20px p-left-6px font-size-18px cursor-point text-hover-red'
                onClick={props.deleteFooterLink}>
                    close</span>
            </div>
        </>
    );
};
